export default __webpack_public_path__ + "static/affiliate-program-Software-2@2x-8706fd4a17a181c85ce44cd720754bf8.webp";